import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { CONFIRM_ACCOUNT_DELETE, TOGGLE_ACCOUNT_DELETION_MARK } from "./gql";

export const useToggleAccountDeletionMark = createDefaultMutationHook(TOGGLE_ACCOUNT_DELETION_MARK);

export const useConfirmAccountDelete = createDefaultMutationHook(CONFIRM_ACCOUNT_DELETE);
